import { Component, Input, Output, EventEmitter } from '@angular/core';
import { ILang } from '../../../model/lang.interface';
import { IErrorDetails } from '../../../model/errordetails.interface';

@Component({
    selector: 'error-popup',
    templateUrl: 'error.popup.component.html',
    styleUrls: ["./error.popup.component.scss"],
})
export class ErrorPopupComponent {
    @Input() active: boolean;
    @Input() currentLang: ILang;
    @Input() error: string;
    @Input() details: IErrorDetails;
    @Output() activeChange: EventEmitter<boolean> = new EventEmitter<boolean>();

    public copied: boolean = false;

    public close(): void {
        this.active = false;
        this.copied = false;
        this.activeChange.emit(false);
    }

    /**
     * Support gets far more out of pasted text than out of a screenshot, so offer both.
     */
    public copyDetails(): void {
        const text = this.detailsAsText();
        if (!text) {
            return;
        }

        const nav: any = navigator;
        if (nav.clipboard && nav.clipboard.writeText) {
            nav.clipboard.writeText(text).then(
                () => { this.copied = true; },
                () => { this.copyFallback(text); }
            );
        } else {
            this.copyFallback(text);
        }
    }

    private detailsAsText(): string {
        if (!this.details) {
            return this.error || "";
        }

        return [
            `fault number: ${this.details.faultNumber}`,
            `message: ${this.details.message}`,
            `time: ${this.details.time}`,
            `company: ${this.details.companyId}`,
            `user: ${this.details.userId}`,
            `version: ${this.details.version}`,
            `platform: ${this.details.platform}`,
            `url: ${this.details.url}`,
        ].join("\n");
    }

    // execCommand is deprecated, but it is still the only option in the older WebViews we ship to.
    private copyFallback(text: string): void {
        try {
            const area = document.createElement("textarea");
            area.value = text;
            area.style.position = "fixed";
            area.style.opacity = "0";
            document.body.appendChild(area);
            area.select();
            document.execCommand("copy");
            document.body.removeChild(area);
            this.copied = true;
        } catch (err) {
            this.copied = false;
        }
    }
}
